import { render, staticRenderFns } from "./SchoolHome.vue?vue&type=template&id=53c861cf"
import script from "./SchoolHome.vue?vue&type=script&lang=js"
export * from "./SchoolHome.vue?vue&type=script&lang=js"
import style0 from "./SchoolHome.vue?vue&type=style&index=0&id=53c861cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports